import type { CapacityType } from '@/types/capacityType';
import apiClient from './axios';

export async function fetchCapacityTypes(): Promise<CapacityType[]> {
  const { data } = await apiClient.get<CapacityType[]>('/capacity-types', { skipGlobalError: true });
  return data;
}
